import { render, staticRenderFns } from "./UserSearches.vue?vue&type=template&id=6a48da5b&"
import script from "./UserSearches.vue?vue&type=script&lang=js&"
export * from "./UserSearches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports